import { useMemo } from 'react';
import { type MasterCategoryType, type MasterSearchFilters, MasterCategoryConst } from '../types/masterSearchTypes';
import { useMasterReferenceQuery } from './useMasterReferenceGetItemListQuery';

// プロパティ名のマッピング定義
const MASTER_PROP_MAP: Record<MasterCategoryType, { code: string; name: string }> = {
  [MasterCategoryConst.SELLER]:     { code: 'sellerCode',    name: 'sellerName' },
  [MasterCategoryConst.BUYER]:      { code: 'buyerCode',     name: 'buyerName' },
  [MasterCategoryConst.FARMER]:     { code: 'farmerCode',    name: 'farmerName' },
  [MasterCategoryConst.VARIETY]:    { code: 'varietyCode',   name: 'varietyName' },
  [MasterCategoryConst.TEA_SEASON]: { code: 'teaSeasonCode', name: 'teaSeasonName' },
  [MasterCategoryConst.TEA_TYPE]:   { code: 'teaTypeCode',   name: 'teaTypeName' },
  [MasterCategoryConst.GAP]:        { code: 'gapCode',       name: 'gapName' },
  [MasterCategoryConst.NOTE]:       { code: 'noteCode',      name: 'noteName' },
  [MasterCategoryConst.BLOCK]:      { code: 'blockCode',     name: 'blockName' },
  [MasterCategoryConst.JA]:         { code: 'jaCode',        name: 'jaName' },
  [MasterCategoryConst.AREA]:       { code: 'areaCode',      name: 'areaName' },
};

export const useClientMasterSearch = (
  category: MasterCategoryType,
  filters: MasterSearchFilters,
  isLoggedIn: boolean
) => {
  const { data, isLoading, error } = useMasterReferenceQuery(isLoggedIn, category);

  const filteredData = useMemo(() => {
    const sourceList = data?.masters ?? [];
    
    // 現在のカテゴリーに対応するプロパティ名を取得
    const propConfig = MASTER_PROP_MAP[category];

    // ★ここが重要: フィルタリング処理
    return sourceList.filter((item) => {
      if (!propConfig) return true;

      // 1. コードと名称の検索
      const itemCode = String(item[propConfig.code] ?? '');
      const itemName = String(item[propConfig.name] ?? '');

      const matchCode = filters.code ? itemCode.startsWith(filters.code) : true;
      const matchName = filters.name ? itemName.includes(filters.name) : true;

      // 2. 論理削除のフィルタリング
      // APIから来る isDeleted (または IsDeleted) が true なら「削除済み」
      const isDeletedItem = (item.isDeleted === true || item.IsDeleted === true);

      const matchDeleted = filters.includeDeleted
        ? true              // チェックONなら、全部表示する (スルー)
        : !isDeletedItem;   // チェックOFFなら、削除済みは隠す (falseだけ通す)

      return matchCode && matchName && matchDeleted;
    });

  }, [category, filters, data]);

  return { data: filteredData, isLoading, error };
};